"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _SettingsWidget = _interopRequireDefault(require("../../03_organisms/SettingsWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MobileSettingsPage = function MobileSettingsPage(_ref) {
  var loggedIn = _ref.loggedIn,
      selectedLanguage = _ref.selectedLanguage,
      version = _ref.version,
      card = _ref.card,
      _ref$savedPassengers = _ref.savedPassengers,
      savedPassengers = _ref$savedPassengers === void 0 ? [] : _ref$savedPassengers,
      _ref$onEditPassengers = _ref.onEditPassengers,
      onEditPassengers = _ref$onEditPassengers === void 0 ? function () {} : _ref$onEditPassengers,
      _ref$onConnect = _ref.onConnect,
      onConnect = _ref$onConnect === void 0 ? function () {} : _ref$onConnect,
      _ref$onLogOut = _ref.onLogOut,
      onLogOut = _ref$onLogOut === void 0 ? function () {} : _ref$onLogOut,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      _ref$onDeleteCard = _ref.onDeleteCard,
      onDeleteCard = _ref$onDeleteCard === void 0 ? function () {} : _ref$onDeleteCard,
      _ref$onDebugToggle = _ref.onDebugToggle,
      onDebugToggle = _ref$onDebugToggle === void 0 ? function () {} : _ref$onDebugToggle,
      _ref$onLanguageEdit = _ref.onLanguageEdit,
      onLanguageEdit = _ref$onLanguageEdit === void 0 ? function () {} : _ref$onLanguageEdit,
      _ref$isDebugOn = _ref.isDebugOn,
      isDebugOn = _ref$isDebugOn === void 0 ? false : _ref$isDebugOn,
      _ref$debugChannel = _ref.debugChannel,
      debugChannel = _ref$debugChannel === void 0 ? '<unset>' : _ref$debugChannel,
      userEmail = _ref.userEmail,
      userPassenger = _ref.userPassenger,
      _ref$onUserPassengerE = _ref.onUserPassengerEdit,
      onUserPassengerEdit = _ref$onUserPassengerE === void 0 ? function () {} : _ref$onUserPassengerE,
      translatorForNamespace = _ref.translatorForNamespace,
      t = _ref.translator;
  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: t('Settings'),
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_SettingsWidget["default"], {
    loggedIn: loggedIn,
    selectedLanguage: selectedLanguage,
    version: version,
    card: card,
    savedPassengers: savedPassengers,
    onEditPassengers: onEditPassengers,
    onConnect: onConnect,
    // onLangChange,
    onLogOut: onLogOut,
    onDeleteCard: onDeleteCard,
    onDebugToggle: onDebugToggle,
    onLanguageEdit: onLanguageEdit,
    isDebugOn: isDebugOn,
    debugChannel: debugChannel,
    userEmail: userEmail,
    userPassenger: userPassenger,
    onUserPassengerEdit: onUserPassengerEdit,
    translatorForNamespace: translatorForNamespace
  }));
};

var _default = MobileSettingsPage;
exports["default"] = _default;